export default "__VITE_ASSET__y1VALf9V__"